import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function NoOrderCard() {
    return (
        <div className="card no-orders-card shadow">
            <div className="card-body d-flex flex-column justify-content-center align-items-center text-muted">
                <FontAwesomeIcon className="fs-1 my-3" icon={["fas", "clock"]}/>
                <div>Zurzeit gibt es noch keine Bestellungen...</div>
            </div>
        </div>
    )
}

export default NoOrderCard